
    <img class="avatar" [src]="src" [srcset]="srcset" alt="" />
  